import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=1f3c8baf&scoped=true&"
import script from "./comment-item.vue?vue&type=script&lang=js&"
export * from "./comment-item.vue?vue&type=script&lang=js&"
import style0 from "./comment-item.vue?vue&type=style&index=0&id=1f3c8baf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c8baf",
  null
  
)

export default component.exports